import { IPagingData, NotificationDto } from '@sr/dto';
import { GridLayout } from 'shared/ui/grid-layout';
import { TableCell, TableRow } from '@mui/material';
import { formatDateTime } from 'utils/date-format-helpers';
import ManagerSpan from 'shared/ui/manager-span';
import { blue } from '@mui/material/colors';

const columns = ['Дата', 'Сообщение', 'Менеджер'];
type Props = {
  items: NotificationDto[],
  totalItemsCount: number
  isLoading: boolean
  pagingData: IPagingData,
  onChangePaging: (paging: IPagingData) => void
  onNotificationClick?: (notification: NotificationDto) => void
}
const NotificationRow = ({ notification, onClick }: {notification: NotificationDto; onClick?: (notification: NotificationDto) => void}) => {
  return <TableRow
    hover
    onClick={() => onClick?.(notification)}
    sx={{ backgroundColor: notification.isRead ? 'primary' : blue[50], cursor: onClick ? 'pointer' : 'default' }}
    key={notification.id}
  >
    <TableCell>{formatDateTime(notification.createdAt)}</TableCell>
    <TableCell>{notification.message}</TableCell>
    <TableCell><ManagerSpan person={notification.manager} /></TableCell>
  </TableRow>;
};
export const NotificationsList = ({ items, isLoading, totalItemsCount, pagingData, onChangePaging, onNotificationClick }: Props) => {
  return (<GridLayout
    columns={columns}
    items={items}
    isLoading={isLoading}
    totalItemsCount={totalItemsCount}
    pagingData={pagingData}
    onChangePaging={onChangePaging}
    noItemsText="Нет уведомлений"
    itemRender={(n) => <NotificationRow notification={n} onClick={onNotificationClick}/>}
  />);
};
